import { render, staticRenderFns } from "./DxMachineryTable.vue?vue&type=template&id=b2e2ad9a&"
import script from "./DxMachineryTable.vue?vue&type=script&lang=js&"
export * from "./DxMachineryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports